import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/designSystem.css";
// Redesign globals (paper grid, rhythm variables, focus on dark surfaces). Last, so its
// :where() rules sit after the legacy CSS; see the header of styles/site.css.
import "@/styles/site.css";
import App from "@/App";
import { loadRuntimeFlags, RUNTIME_FLAGS_TIMEOUT_MS } from "@/config";

const render = () => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
};

// Pull the backend's enabled feature flags (GET /api/flags, DB-free) before the first
// render so flag() stays synchronous everywhere. Bounded at 1500 ms and never
// rejects; on failure the build-time flags apply unchanged.
loadRuntimeFlags({ timeoutMs: RUNTIME_FLAGS_TIMEOUT_MS }).finally(render);
